/** Production factory: the real global `WebTransport` constructor. Throws in an environment (or browser) that does not implement it. */
export function defaultWebTransportFactory(url, options) {
    const Ctor = globalThis.WebTransport;
    if (Ctor === undefined) {
        throw new Error("WebTransport is not available in this environment");
    }
    return new Ctor(url, options);
}
//# sourceMappingURL=contract.js.map